/* Stapl sections: carousels, purchase-option toggle, reveal on scroll.
   Re-initialises when a section is added or edited in the theme editor. */
(function () {
  function initCarousels(root) {
    root.querySelectorAll('[data-s-track]').forEach(function (track) {
      if (track.dataset.sReady) return;
      track.dataset.sReady = '1';
      var section = track.closest('.stapl') || document;
      var btns = section.querySelectorAll('[data-s-dir]');
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        btns.forEach(function (b) {
          b.disabled = Number(b.dataset.sDir) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
          track.scrollBy({ left: step * Number(b.dataset.sDir), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initOptions(root) {
    root.querySelectorAll('[data-s-opts]').forEach(function (group) {
      if (group.dataset.sReady) return;
      group.dataset.sReady = '1';
      var note = group.parentElement.querySelector('[data-s-note]');
      group.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function () {
          group.querySelectorAll('.s-opt').forEach(function (o) {
            o.classList.toggle('is-on', o.contains(input) && input.checked);
          });
          if (note) note.textContent = input.dataset.note || '';
        });
      });
    });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('.s-reveal').forEach(function (el) {
      if (!io || (window.Shopify && window.Shopify.designMode)) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  function init(root) {
    root = root || document;
    initCarousels(root);
    initOptions(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var track = e.target.closest('[data-s-track]');
    if (track) e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
})();
